<template>
  <div>
    <PrimaryBox :flag="true">
      <template slot="title">应急动态</template>
      <div class="content">
        <div class="outBox">
          <div class="bottoms">
            <Icon type="ios-loading" v-if="eventLoading" class="xvanzhuan" size="60"/>
            <div v-else>
              <VueSeamlessScroll v-if="eventList.length>0" :data="eventList" class="content"
                                 :class-option="defaultOption">
                <div v-for="(item,index) in eventList" :key="index" class="itemBox" @click="getEventById(item)">
                  <img class="img" :src="getImg(item)" alt=""/>
                  <p class="title">{{ item.eventTitle }}</p>
                  <p class="iconLabel">
                    <el-tag effect="plain" color="#4A1515" :hit="true" size="mini" type="danger"
                            v-if="item.status==='未处置'">未处置
                    </el-tag>
                    <el-tag :hit="true" size="mini" color="#ccc" type="info" v-if="item.status==='处置中'">处置中
                    </el-tag>
                    <el-tag :hit="true" size="mini" type="success" color="#333333"
                            v-if="item.status==='已处置'||item.status==='已完成'">{{ item.status }}
                    </el-tag>
                  </p>
                  <p class="eventDescription">{{ item.eventDescription }}</p>
                  <p class="eventReceptionTime">{{ $moment(item.eventReceptionTime).format('yyyy-MM-DD') }}</p>
                </div>
              </VueSeamlessScroll>
              <div v-else>
                <div style="width: 100%;height: 25vh;text-align: center;line-height: 25vh;">
                  <span style="color: #2b85e4;font-size: .9rem;font-weight: bold;">暂无数据</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PrimaryBox>
  </div>
</template>

<script>
import PrimaryBox from "@/views/Screen/components/PrimaryBox/PrimaryBox";
import DynamicJianKong from '../../images/dynamic_jiankong.png';
import dynamicYujing from '../../images/dynamic_yujing.png';
import dynamicLukuang from '../../images/dynamic_lukuan.png';
import VueSeamlessScroll from "vue-seamless-scroll";

export default {
  name: "EventDynamic",
  components: {
    PrimaryBox,
    VueSeamlessScroll
  },
  computed: {
    defaultOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  data() {
    return {
      eventLoading: false,
      IconRedList: [ dynamicYujing,DynamicJianKong, dynamicLukuang, dynamicYujing],
      eventList: []
    }
  },
  mounted() {
    this.getEventList()
  },
  methods: {
    getImg(item) {
      let types = item.eventType === null ? '0' : parseInt(item.eventType) > 3 ? '0' : item.eventType;
      return this.IconRedList[parseInt(types)];
    },
    getEventList() {
      this.eventLoading = true
      this.$http.post('/api/getMessageList', {
        reportingChannels: 1
      }).then(res => {
        if (res.status === 200) {
          this.eventList = res.data.data;
          this.eventLoading = false
        }
      })
    },
    getEventById(item) {
      this.$http.get(`/api/messageReceptions/${item.id}`).then(res => {
        this.firstDescription = res.data
      })
      this.$http.get(`/api/getMessageReceptionRecordsList/${item.id}`).then(res => {
        if (res.status === 200) {
          this.timeLineList = res.data;
          if (this.timeLineList.length > 0) {
            this.timeLineList[0].color = '#13C8FC'
          }
        }
      })
      // 在地图上居中显示
      this.$emit('getEventById', item)
    }
  },
}

</script>

<style scoped lang="less">
@import "EventDynamic.less";

@keyframes xvanzhuan {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg)
  }
}

.xvanzhuan {
  animation: xvanzhuan 1s linear infinite;
  text-align: center;
  margin-top: 30%;
  margin-left: 47%;
  transform: translateX(-50%);
}
</style>
